import csatWorkersType from './action-types'
import { FetchCsatWorkersPayload } from './types'

export const fetchCsatWorkers = ({ options }: { options: FetchCsatWorkersPayload }) => ({
  type: csatWorkersType.ENTITIES_FETCH_BEGIN,
  options,
})

export type FetchCsatWorkersAction = ReturnType<typeof fetchCsatWorkers>
